import { ProBadge } from "@/components/ui/pro-badge";
import { cn } from "@/lib/utils";

/**
 * Renders the minimal "PRO" pill next to a premium user's name.
 * Kept under the original name for backwards compatibility.
 */
export function PremiumBadge({
  isPremium,
  size = "sm",
  className,
}: {
  isPremium: boolean;
  size?: "xs" | "sm" | "md";
  className?: string;
}) {
  if (!isPremium) return null;
  return (
    <ProBadge
      size={size}
      aria-label="Embaixador PRO"
      className={cn("align-middle", className)}
    />
  );
}

export default PremiumBadge;
